// Grupo de permisos (Perfiles / Usuarios) que SOLO el usuario master
// (state.user.tipo === 0) puede asignar. Filtrar por el id del grupo permite que,
// si en el futuro se agregan más permisos a este grupo, queden restringidos
// automáticamente sin tocar este archivo.
export const GRUPO_SOLO_MASTER = "6a231389903358dc7da8a86f";

// Respaldo por id de permiso individual, por si algún permiso solo-master
// llegara a vivir fuera del grupo anterior.
export const PERMISOS_SOLO_MASTER = [
  // Perfiles
  "6a2313c5903358dc7da8a899", // Acceso
  "6a2313d3903358dc7da8a89a", // Agregar
  "6a2313df903358dc7da8a89b", // Editar
  "6a2313fa903358dc7da8a89d", // Deshabilitar
  // Usuarios
  "6a231408903358dc7da8a8a8", // Acceso
  "6a23141d903358dc7da8a8b7", // Agregar
  "6a23142c903358dc7da8a8bd", // Editar
  "6a231506903358dc7da8a99c", // Cambiar contraseña
  "6a231516903358dc7da8a9bb", // Deshabilitar usuario
  // Editar Usuario
  "6a23144f903358dc7da8a8be", // Asignar proyecto
  "6a2314ae903358dc7da8a96f", // Asignar perfil
  "6a2314cc903358dc7da8a98e", // Asignar permisos individuales
  "6a2314e8903358dc7da8a992", // Cambiar nombre de usuario
];

const setSoloMaster = new Set(PERMISOS_SOLO_MASTER);

const esGrupoSoloMaster = (grupo) => {
  const id = (grupo.grupoId || grupo._id || "").toString();
  return id === GRUPO_SOLO_MASTER;
};

// Devuelve una copia del catálogo de permisos (grupos -> permisos) en la que,
// para usuarios no-master, se excluye el grupo solo-master (y, como respaldo,
// cualquier permiso solo-master suelto) y los grupos que queden vacíos.
// Solo afecta al render; no modifica los valores almacenados.
export const filtrarCatalogoSoloMaster = (todasPermisos, tipo) => {
  if (!Array.isArray(todasPermisos)) return todasPermisos;
  if (tipo === 0) return todasPermisos;
  return todasPermisos
    .filter((grupo) => !esGrupoSoloMaster(grupo))
    .map((grupo) => ({
      ...grupo,
      permisos: (grupo.permisos || []).filter(
        (perm) => !setSoloMaster.has(perm._id.toString())
      ),
    }))
    .filter((grupo) => (grupo.permisos || []).length > 0);
};

// Normaliza texto para buscar: minúsculas, sin acentos y sin espacios sobrantes.
const normalizar = (texto) =>
  (texto ?? "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();

// Filtra el catálogo (grupos -> permisos) según un texto de búsqueda que puede
// coincidir con el nombre del grupo, del subgrupo o del permiso.
//   - Si coincide el nombre del grupo, se conserva el grupo completo.
//   - Si coincide el nombre de un subgrupo, se conservan los permisos de ese subgrupo.
//   - Si coincide el nombre de un permiso, se conserva ese permiso.
// Devuelve una copia; solo afecta al render, nunca modifica los valores guardados.
export const filtrarCatalogoPorBusqueda = (todasPermisos, busqueda) => {
  if (!Array.isArray(todasPermisos)) return todasPermisos;
  const q = normalizar(busqueda);
  if (!q) return todasPermisos;
  return todasPermisos
    .map((grupo) => {
      if (normalizar(grupo.nombre).includes(q)) return grupo;
      const permisos = (grupo.permisos || []).filter((perm) => {
        const sub = perm.subgrupo || {};
        return (
          normalizar(perm.nombre).includes(q) ||
          normalizar(sub.nombre).includes(q)
        );
      });
      return { ...grupo, permisos };
    })
    .filter((grupo) => (grupo.permisos || []).length > 0);
};
